import React from "react";
import '../styles/components/ContactInfos.css'
import location from '../assets/images/icons/map.png'
import email from '../assets/images/icons/email.png'
import phone from '../assets/images/icons/phone.png'

const ContactInfos = () => {

    return (
        <>
            <div className='contact-infos'>
                <h1>تواصـــل معي</h1>
                <div className='figures'>
                    <div className='figure'>
                        <img src={location} alt='location'/>
                        <div className='caption'>
                            <h1>المكـــان</h1>
                            <p>123 Fifth Avenue,New York, NY 10160</p>
                        </div>
                    </div>
                    <div className='figure'>
                        <img src={email} alt='email'/>
                        <div className='caption'>
                            <h1>البـــــريد</h1>
                            <p> contact@hello.com</p>
                        </div>
                    </div>
                    <div className='figure'>
                        <img src={phone} alt='phone'/>
                        <div className='caption'>
                            <h1>الهــاتف</h1>
                            <p> +1 910-626-85255</p>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default ContactInfos;